<template>
  <section>
    <header-portal></header-portal>
    <template>
      <v-stepper v-model="e13" vertical>
        <v-stepper-step :complete="e13 > 1" step="1" :editable="e13 !==3" @click="clearLoaders(), crearImagenCaptcha()">
          <h4><v-icon color="primary">person</v-icon> Datos Personales</h4>
        </v-stepper-step>
        <v-stepper-content step="1">
          <!-- inicio de paso 1 -->
           <div class="decretosBoton">
          <v-menu bottom>
      <template v-slot:activator="{ on }">
        <v-btn v-on="on" small tile outline color="primary">
           <v-icon dark>keyboard_arrow_down</v-icon>&nbsp;Asistencia
          </v-btn>
      </template>
      <v-card class="px-2 py-1">
        <v-card-text class="black--text body-2">
          <v-icon small color="info">info</v-icon>&nbsp;
          <span>Los datos en esta sección se contrastarán con <strong>SEGIP</strong> por favor verifique sus datos.</span>
        </v-card-text>
      </v-card>
    </v-menu>
        </div>
          <v-alert v-if="form.tipdoc_codigo === '1'"
          class="decretos"
            color="info"
            :value="true">
            <p><v-icon>info</v-icon> Los datos en esta sección se contrastarán con <strong>SEGIP</strong> por favor verifique sus datos.</p>
          </v-alert>
          <v-card>
            <v-card-text>
              <v-form v-model='valid' ref='formPersonales' lazy-validation>
                <v-layout row wrap>
                  <v-flex md8 offset-md2>
                    <v-layout row wrap>
                      <v-flex md6 xs12>
                        <v-select
                          :no-data-text="$t('comun.sin_datos')"
                          v-model="form.tipdoc_codigo"
                          :items="itemsTipoDocumentoIdentidad"
                          item-text='tipo_documento'
                          item-value='tipo_documento_codigo'
                          label='Tipo de Documento*'
                          :rules='dRules'
                          required
                          prepend-icon="credit_card"
                        ></v-select>
                      </v-flex>
                      <v-flex md6 xs12 v-if="form.tipdoc_codigo === '1'">
                        <v-select
                          :no-data-text="$t('comun.sin_datos')"
                          v-model='tipoNacionalidad'
                          :items='itemsTipoNacionalidad'
                          item-text='tipoNacionalidad_descripcion'
                          item-value='tipoNacionalidad_codigo'
                          label='Nacionalidad*'
                          persistent-hint
                          prepend-icon="public"
                        ></v-select>
                      </v-flex>
                    </v-layout>
                  </v-flex>
                </v-layout>
                <v-layout row wrap v-if="form.tipdoc_codigo === '1'">
                  <v-flex md8 offset-md2>
                    <v-layout row wrap>
                      <v-flex md8 xs12>
                       <v-text-field
                         v-model="form.numero_docidentidad"
                         label='Número de Cédula de Identidad*'
                         :rules='ciRules'
                         maxlength='9'
                         required
                         prepend-icon="fingerprint"
                       ></v-text-field>
                      </v-flex>
                      <v-flex md4 xs12>
                        <v-text-field
                          v-model="form.sufijo_docidentidad"
                          label='Complemento SEGIP'
                          maxlength='2'
                          :rules='complementoRules'
                          prepend-icon="fingerprint"
                          class="text-normal"
                        ></v-text-field>
                      </v-flex>
                    </v-layout>
                  </v-flex>
                </v-layout>
                <v-layout row wrap v-if="form.tipdoc_codigo === '3'">
                  <v-flex md8 offset-md2>
                    <v-layout row wrap>
                      <v-flex md12 xs12>
                        <v-text-field
                          v-model="form.prefijo_docidentidad"
                          label='Prefijo Pasaporte'
                          maxlength='5'
                          :rules="textAreaRules"
                          prepend-icon="keyboard_arrow_left"
                        ></v-text-field>
                      </v-flex>
                      <v-flex md12 xs12>
                        <v-text-field
                          v-model="form.numero_docidentidad"
                          label='Valor Númerico de Pasaporte*'
                          :rules='ciRules'
                          maxlength='9'
                          required
                          prepend-icon="fingerprint"
                        ></v-text-field>
                      </v-flex>
                      <v-flex md12 xs12>
                        <v-text-field
                          v-model="form.sufijo_docidentidad"
                          label='Sufijo Pasaporte'
                          maxlength='5'
                          :rules="textAreaRules"
                          prepend-icon="keyboard_arrow_right"
                        ></v-text-field>
                      </v-flex>
                    </v-layout>
                  </v-flex>
                </v-layout>
                <v-layout row wrap>
                  <v-flex md8 offset-md2>
                    <v-layout row wrap>
                      <v-flex md6 xs12>
                       <v-text-field
                         v-model="form.perdec_appaterno"
                         label='Apellido Paterno'
                         :rules="textAreaRules"
                         maxlength='100'
                         prepend-icon="edit"
                       ></v-text-field>
                      </v-flex>
                      <v-flex md6 xs12>
                        <v-text-field
                          v-model="form.perdec_apmaterno"
                          label='Apellido Materno'
                          :rules="textAreaRules"
                          maxlength='100'
                          prepend-icon="edit"
                        ></v-text-field>
                      </v-flex>
                    </v-layout>
                  </v-flex>
                </v-layout>
                <v-layout row wrap>
                  <v-flex md8 offset-md2>
                    <v-text-field
                      v-model="form.perdec_nombres"
                      :rules='textRules'
                      maxlength='100'
                      label='Nombres*'
                      required
                      prepend-icon="edit"
                    ></v-text-field>
                  </v-flex>
                </v-layout>
                <v-layout row wrap>
                  <v-flex md8 offset-md2>
                    <v-layout row wrap>
                      <v-flex md6 xs12>
                       <v-select
                          :no-data-text="$t('comun.sin_datos')"
                          v-model='form.perdec_genero'
                          :items='itemsGenero'
                          item-text='tipo_genero'
                          item-value='tipo_genero_codigo'
                          label='Género*'
                          :rules='dRules'
                          required
                          persistent-hint
                          prepend-icon="wc"
                        ></v-select>
                      </v-flex>
                      <v-flex md6 xs12>
                        <global-date-input-picker
                          v-model="date" :hint="'Formato DD/MM/AAAA'" :rules="dateRules" label="Fecha de Nacimiento*">
                        </global-date-input-picker> 
                      </v-flex>
                    </v-layout>
                  <v-layout wrap>
                    <v-flex sm12 md12>
                       <v-subheader>
                        <p class='plomo--text'>Por favor llene los campos requeridos*</p>
                       </v-subheader>
                    </v-flex>
                  </v-layout>
                  </v-flex>
                </v-layout>
                <b>Digite las letras y/o números que aparecen en la Imagen </b>
                <v-layout row wrap>
                  <v-flex md3 offset-md1>
                    <img
                      :src="imgb64"
                      alt="Bolivia">
                  </v-flex>
                  <v-flex md3 offset-md1>
                    <v-text-field
                      v-model="form.captcha"
                      label='Respuesta'
                      :rules='this.useCaptcha ? dRules : []'
                      :required="this.useCaptcha"
                      :maxlength="this.lengthCaptcha"
                    ></v-text-field>
                  </v-flex>
                  <v-flex md1>
                    <v-icon large @click="crearImagenCaptcha()">cached</v-icon>
                  </v-flex>
                </v-layout>
              </v-form>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
               <v-btn
                color="primary"
                @click="verificarDatos(), loader = 'loadingButton'"
                :loading="loadingButton"
                :disabled="loadingButton"
                >
                <v-icon>arrow_forward_ios</v-icon>&nbsp;Siguiente
                <template v-slot:loader>
                 <span>procesando..</span>
                  </template>
              </v-btn>
              <v-btn
                color="error"
                :disabled="buttonCancel"
                @click="$router.push('/')">
                <v-icon>cancel</v-icon>&nbsp;Cancelar
              </v-btn>
            </v-card-actions>
          </v-card>
          <!-- fin de paso 1 -->
        </v-stepper-content>

        <v-stepper-step  :complete="e13 > 2" step="2" :editable='false'>
          <h4><v-icon color="primary">account_circle</v-icon> Datos de la Cuenta </h4>
        </v-stepper-step>
        <v-stepper-content step="2">
          <!-- inicio de paso 2 -->
          <v-card>
            <v-card-text>
              <v-form v-model='valid' ref='formCuenta' lazy-validation>
                <v-layout row wrap>
                  <v-flex md8 offset-md2>
                    <v-layout>
                      <v-flex md6>
                        <v-text-field
                          class="text-normal"
                          v-model="form.correo1"
                          :rules='!this.correoOk ? correoRule : []'
                          :required="!this.correoOk"
                          label='Correo Electrónico Personal'
                          prepend-icon="email"
                        ></v-text-field>
                      </v-flex>
                      <v-flex md6>
                        <v-text-field
                          v-model="form.cuefundec_telefono_celular"
                          label='Número de Celular Personal*'
                          :rules='celularRules'
                          maxlength='8'
                          required
                          prepend-icon="phone"
                        ></v-text-field>
                      </v-flex>
                    </v-layout>
                  </v-flex>
                </v-layout>
                <v-layout row wrap>
                  <v-flex md8 offset-md2>
                    <v-text-field
                      style="font-size: 20px;"
                      v-model="form.cuefundec_contrasenia"
                      label='Contraseña*'
                      class="text-normal"
                      maxlength='20'
                      :rules='passRule'
                      required
                      type='password'
                      prepend-icon="security"
                    ></v-text-field>
                  </v-flex>
                </v-layout>
                <v-layout row wrap>
                  <v-flex md8 offset-md2>
                    <v-text-field
                      style="font-size: 20px;"
                      v-model="form.cuefundec_contrasenia2"
                      label='Repetir Contraseña*'
                      maxlength='20'
                      class="text-normal"
                      :rules='passRule'
                      required
                      type='password'
                      prepend-icon="security"
                    ></v-text-field>
                  </v-flex>
                </v-layout>
              </v-form>
              <v-layout wrap>
                    <v-flex sm12 md12>
                       <v-subheader>
                        <p class='plomo--text'>Por favor llene los campos requeridos*</p>
                       </v-subheader>
                    </v-flex>
                  </v-layout>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                color="primary"
                :loading="loadingButton"
                :disabled="loadingButton"
                @click="crearCuenta(), loader = 'loadingButton'">
                <v-icon>arrow_forward_ios</v-icon>&nbsp;Siguiente
                <template v-slot:loader>
                     <span>procesando..</span>
                     </template>
              </v-btn>
            </v-card-actions>
          </v-card>
          <!-- fin de paso 2 -->
        </v-stepper-content>

        <v-stepper-step  :complete="e13 > 3" step="3" :editable='false'>
          <h4><v-icon color="primary">done_all</v-icon> Cuenta Creada</h4>
        </v-stepper-step>
        <v-stepper-content step="3">
          <!-- inicio de paso 3 -->
          <v-card>
            <div ref="pdf">
            <v-card-text>
               <div class="decretosBoton">
          <v-menu bottom>
      <template v-slot:activator="{ on }">
        <v-btn v-on="on" small tile outline color="primary">
           <v-icon dark>keyboard_arrow_down</v-icon>&nbsp;Asistencia
          </v-btn>
      </template>
      <v-card class="px-2 py-1">
        <v-card-text class="black--text body-2">
          <v-icon small color="info">info</v-icon>&nbsp;
          <span>Tome nota de la cuenta creada para ingresar al sistema.</span>
        </v-card-text>
      </v-card>
    </v-menu>
        </div>
              <v-alert
              class="decretos"
                color="info"
                :value="true" >
                <div class="text-xs-justify">
                  <h4>Tome nota de la cuenta creada para ingresar al sistema.</h4>
                </div>
              </v-alert>
              Se creo la cuenta:
              <v-layout wrap>
                <v-flex md4 offset-md4>
                  <h3><strong>{{ this.form.cuefundec_cuenta.toUpperCase() }}</strong></h3>
                </v-flex>
              </v-layout>
              <p>Con los siguientes datos personales:</p><br/>
              <v-layout wrap>
                <v-flex xs6 md4>
                  Documento de Identificación
                  <p><strong>{{ this.form.tipdoc_codigo === '1' ? this.itemsTipoDocumentoIdentidad[0].tipo_documento : this.form.tipdoc_codigo === '3' ? this.itemsTipoDocumentoIdentidad[1].tipo_documento :  '' }}</strong></p>
                </v-flex>
                <v-flex xs6 md4>
                  Número de Documento
                  <p><strong>{{ this.form.numero_docidentidad }}</strong></p>
                </v-flex>
                <v-flex xs6 md4>
                  Fecha de Nacimiento
                  <p><strong>{{ this.date }}</strong></p>
                </v-flex>
              </v-layout>
              <v-layout wrap>
                <v-flex xs6 md4>
                  Apellido Paterno
                  <p><strong>{{ this.form.perdec_appaterno.toUpperCase() }}</strong></p>
                </v-flex>
                <v-flex xs6 md4>
                  Apellido Materno
                  <p><strong>{{ this.form.perdec_apmaterno.toUpperCase() }}</strong></p>
                </v-flex>
                <v-flex xs6 md4>
                  Nombres
                  <p><strong>{{ this.form.perdec_nombres.toUpperCase() }}</strong></p>
                </v-flex>
              </v-layout>
              <v-layout wrap>
                <v-flex xs6 md4>
                  Género
                  <p><strong>{{ this.form.perdec_genero !== '' ? this.itemsGenero[parseInt(this.form.perdec_genero)].tipo_genero : '' }}</strong></p>
                </v-flex>
                <v-flex xs6 md4>
                  Dirección de Correo Electrónico Personal
                  <p><strong>{{ this.form.correo1 }}</strong></p>
                </v-flex>
                <v-flex xs6 md4>
                  Número de Celular Personal
                  <p><strong>{{ this.form.cuefundec_telefono_celular }}</strong></p>
                </v-flex>
              </v-layout>
            </v-card-text>
            </div>
             <p>Imprima esta página y apersonese a la CGE a efectos de corregir los datos en caso de encontrar algo incorrecto</p>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="primary" @click="generarPDF()"><v-icon>print</v-icon>&nbsp;Imprimir Creación de Cuenta</v-btn>
               <v-btn color="error" @click="$router.push('/')"><v-icon>done_all</v-icon>&nbsp;Terminar</v-btn>
            </v-card-actions>
          </v-card>
          <!-- fin de paso 3 -->
        </v-stepper-content>
      </v-stepper>
    </template>
  </section>
</template>
<script>
// import Jspdf from 'jspdf';
import HeaderPortal from '@/components/djbrd/headerPortal.vue';
import Segip from '../mixins/segip.js';
import Captcha from '../mixins/captcha.js';
import Cuenta from '../mixins/cuentas.js';
let sha256 = require('sha256');

export default {
  mixins: [ Segip, Captcha, Cuenta ],
  components: {
    HeaderPortal
  },
  created () {
    this.crearImagenCaptcha();
  },
  data: () => ({
    sha256DatosSegip: '',
    e13: 1,
    valid: true,
    dialogVisible: false,
    tipoNacionalidad: '1',
    form: {
      tipdoc_codigo: '1',
      prefijo_docidentidad: '',
      numero_docidentidad: '',
      sufijo_docidentidad: '',
      perdec_appaterno: '',
      perdec_apmaterno: '',
      perdec_nombres: '',
      perdec_genero: '',
      cuefundec_telefono_celular: '',
      correo1: '',
      cuefundec_cuenta: '',
      cuefundec_contrasenia: '',
      cuefundec_contrasenia2: '',
      captcha: ''
    },
    itemsTipoDocumentoIdentidad: [
      {
        tipo_documento: 'Cédula de Identidad',
        tipo_documento_codigo: '1'
      },
      {
        tipo_documento: 'Pasaporte',
        tipo_documento_codigo: '3'
      }
    ],
    itemsTipoNacionalidad: [
      {
        tipoNacionalidad_descripcion: 'Nacional',
        tipoNacionalidad_codigo: '1'
      },
      {
        tipoNacionalidad_descripcion: 'Extranjero',
        tipoNacionalidad_codigo: '2'
      }
    ],
    itemsGenero: [
      {
        tipo_genero: 'FEMENINO',
        tipo_genero_codigo: '0'
      },
      {
        tipo_genero: 'MASCULINO',
        tipo_genero_codigo: '1'
      }
    ],
    // segipContrastacion: {
    //   complemento: 0,
    //   complementoVisible: 0,
    //   fechaNacimiento: 0,
    //   nombres: 0,
    //   numeroDocumento: 0,
    //   primerApellido: 0,
    //   segundoApellido: 0
    // },
    imgb64: '',
    tokenCaptcha: '',
    useCaptcha: process.env.USE_CAPTCHA,
    lengthCaptcha: process.env.LENGTH_CAPTCHA,
    loader: null,
    loadingButton: false,
    buttonCancel: false,
    correoOk: false,
    menu: false,
    date: '',
    dRules: [v => !!v || 'Este campo es requerido'],
    correoRule: [],
    passRule: [v => /^(?=.*?[A-Z])(?=(.*[a-z]){1,})(?=(.*[\d]){1,})(?=(.*[\W_]){1,})(?!.*\s).{8,}$/.test(v) || 'Debe tener al menos 8 caracteres, una letra mayúscula (A-Z), minúscula (a-z), un número (0-9) y un caracter especial, por ejemplo ( @ # $ % ^ & * ç )'],
    dateRules: [v => !!v || 'Este campo es requerido',
      v => (v && v.length <= 10) || 'El formato requerido DD/MM/AAAA sólo tiene 10 campos',
      v => (v && /^(0[1-9]|[12][0-9]|3[01])[- /.](0[1-9]|1[012])[- /.](18|19|20|21|22|23)\d\d$/.test(v)) || 'Fecha no válida'],
    ciRules: [
      v => !!v || 'El número de Documento es requerido',
      v => /^[0-9]*$/.test(v) || 'El número de Documento no es válido'
    ],
    complementoRules: [
      v => (!/^[CH]+$/.test(v)) || 'El complemento no corresponde a un departamento de expedición',
      v => (!/^[LP]+$/.test(v)) || 'El complemento no corresponde a un departamento de expedición',
      v => (!/^[CB]+$/.test(v)) || 'El complemento no corresponde a un departamento de expedición',
      v => (!/^[OR]+$/.test(v)) || 'El complemento no corresponde a un departamento de expedición',
      v => (!/^[PT]+$/.test(v)) || 'El complemento no corresponde a un departamento de expedición',
      v => (!/^[TJ]+$/.test(v)) || 'El complemento no corresponde a un departamento de expedición',
      v => (!/^[SC]+$/.test(v)) || 'El complemento no corresponde a un departamento de expedición',
      v => (!/^[BN]+$/.test(v)) || 'El complemento no corresponde a un departamento de expedición',
      v => (!/^[PN]+$/.test(v)) || 'El complemento no corresponde a un departamento de expedición'
    ],
    celularRules: [
      v => (v && v.length <= 8) || 'Este campo es requerido',
      v => /^[0-9]*$/.test(v) || 'El número de celular no es válido'
    ],
    textAreaRules: [v => v === '' ? true : /^[a-zA-Z0-9-_/.*()',.;:=#°ñÑÁáÉéÍíóÓúÚäÄëËïÏöÖüÜÇç \r\n]+$/.test(v) || 'Carácter especial no permitido'],
    textRules: [v => !!v || 'Este campo es requerido',
      v => /^[a-zA-Z0-9-_/.*()"“”',.;:=#°ñÑÁáÉéÍíóÓúÚäÄëËïÏöÖüÜÇç \r\n]+$/.test(v) || 'Carácter especial no permitido'],
    perdec_codigo: ''
  }),
  methods: {
    async crearImagenCaptcha () {
      this.form.captcha = '';
      let result = await this.makeText();
      this.tokenCaptcha = result.token;
      this.imgb64 = this.generateCaptcha(result.captcha);
    },
    b64toBlob (b64Data, contentType, sliceSize) {
      contentType = contentType || '';
      sliceSize = sliceSize || 512;
      let byteCharacters = atob(b64Data);
      let byteArrays = [];
      for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
        let slice = byteCharacters.slice(offset, offset + sliceSize);
        let byteNumbers = new Array(slice.length);
        for (let i = 0; i < slice.length; i++) {
          byteNumbers[i] = slice.charCodeAt(i);
        }
        let byteArray = new Uint8Array(byteNumbers);
        byteArrays.push(byteArray);
      }
      let blob = new Blob(byteArrays, {type: contentType});
      return blob;
    },
    generarPDF () {
      // this.$storage.set('token', process.env.TOKEN_EXTERNO);
      this.$service.get(`reporte/jasper_crea_cuenta`).then(response => {
        if (response) {
          const url = window.URL.createObjectURL(this.b64toBlob(response, 'application/pdf'));
          const link = document.createElement('a');
          link.href = url;
          link.setAttribute('download', `CREACION_CUENTA.pdf`);
          document.body.appendChild(link);
          link.click();
          this.$storage.remove('token');
        }
      }).catch(err => {
        console.log(err);
        this.$storage.remove('token');
      });
    },
    async verificarDatos () {
      if (this.form.sufijo_docidentidad === 'lp' || this.form.sufijo_docidentidad === 'cb' || this.form.sufijo_docidentidad === 'sc' ||
          this.form.sufijo_docidentidad === 'pt' || this.form.sufijo_docidentidad === 'or' || this.form.sufijo_docidentidad === 'ch' ||
          this.form.sufijo_docidentidad === 'tj' || this.form.sufijo_docidentidad === 'bn' || this.form.sufijo_docidentidad === 'pn') {
        this.$message['warning']('El complemento no es un departamento de expedición por ejemplo 1234567-1j');
        this.form.sufijo_docidentidad = '';
      }
      if (!(!!this.form.perdec_apmaterno || !!this.form.perdec_appaterno)) {
        this.$message['warning']('Al menos uno de los apellidos es requerido');
      }
      if (this.$refs.formPersonales.validate() && (!!this.form.perdec_apmaterno || !!this.form.perdec_appaterno)) {
        this.buttonCancel = !this.buttonCancel;
        this.loadingButton = true;
        if (this.form.tipdoc_codigo === '1') {
          let params = {
            tipo_persona: this.tipoNacionalidad,
            NumeroDocumento: this.form.numero_docidentidad,
            FechaNacimiento: this.date,
            PrimerApellido: this.form.perdec_appaterno,
            SegundoApellido: this.form.perdec_apmaterno,
            nombres: this.form.perdec_nombres,
            token: this.tokenCaptcha,
            captcha: this.form.captcha
          };
          if (this.form.sufijo_docidentidad !== '') {
            params.NumeroDocumento = `${this.form.numero_docidentidad}-${this.form.sufijo_docidentidad}`;
          }
          let responseSegip = await this.contrastarSegip(params).then(resp => {
            if (resp.err_existente === 0) {
              this.$message['success'](resp.err_mensaje);
              resp.finalizado = true;
            }
            if (resp.err_existente === 1) {
              this.$message['info'](resp.err_mensaje);
              resp.finalizado = false;
            }
            if (resp.error_codigo === 503) {
              this.$message['info']('El servicio de contrastación no está disponible, se continuará sin esta verificación.', 'SEGIP', {timeout: 15000});
              resp.finalizado = true;
            }
            if (resp.error_codigo === 500) {
              this.$message['info']('El servicio de contrastación cuenta con error en el formato de respuesta, se continuará sin esta verificación.', 'SEGIP', {timeout: 15000});
              resp.finalizado = true;
            }
            return resp;
          }).catch(e => {
            console.log(e);
            this.loadingButton = false;
            return e;
          });
          // this.segipContrastacion = responseSegip.camposComparados;
          if (responseSegip.finalizado === true) {
            let paramsVerificar = {
              prefijo_docidentidad: this.form.prefijo_docidentidad,
              numero_docidentidad: this.form.numero_docidentidad,
              sufijo_docidentidad: this.form.sufijo_docidentidad,
              tipdoc_codigo: this.form.tipdoc_codigo,
              perdec_fecha_nacimiento: this.date,
              perdec_appaterno: this.form.perdec_appaterno,
              perdec_apmaterno: this.form.perdec_apmaterno,
              perdec_nombres: this.form.perdec_nombres
            };
            this.$storage.set('token', process.env.TOKEN_EXTERNO);
            this.$service
            .post(`control_tarjeta/cuenta_uid`, paramsVerificar)
            .then(response => {
              this.$storage.remove('token');
              if (response) {
                this.form.cuefundec_cuenta = response.inf_codigo;
                this.sha256DatosSegip = sha256(JSON.stringify(this.form));
                this.e13 = 2;
                this.loadingButton = false;
                this.buttonCancel = false;
              } else {
                this.loadingButton = false;
                this.buttonCancel = false;
              }
            }).catch(err => {
              this.$storage.remove('token');
              console.log(err);
              this.clearLoaders();
            });
            this.$storage.remove('token');
          } else {
            this.loadingButton = false;
            this.buttonCancel = false;
            this.crearImagenCaptcha();
          }
        }
        if (this.form.tipdoc_codigo === '3') {
          let paramsVerificar = {
            prefijo_docidentidad: this.form.prefijo_docidentidad,
            numero_docidentidad: this.form.numero_docidentidad,
            sufijo_docidentidad: this.form.sufijo_docidentidad,
            tipdoc_codigo: this.form.tipdoc_codigo,
            perdec_fecha_nacimiento: this.date,
            perdec_appaterno: this.form.perdec_appaterno,
            perdec_apmaterno: this.form.perdec_apmaterno,
            perdec_nombres: this.form.perdec_nombres
          };
          this.$storage.set('token', process.env.TOKEN_EXTERNO);
          this.$service
          .post(`control_tarjeta/cuenta_uid`, paramsVerificar)
          .then(response => {
            this.$storage.remove('token');
            if (response) {
              this.form.cuefundec_cuenta = response.inf_codigo;
              this.sha256DatosSegip = sha256(JSON.stringify(this.form));
              this.e13 = 2;
              this.clearLoaders();
            } else {
              this.clearLoaders();
            }
          }).catch(err => {
            this.$storage.remove('token');
            console.log(err);
            this.clearLoaders();
          });
        }
      } else {
        this.clearLoaders();
        this.$message['warning']('Verificación Incorrecta, Datos requeridos incompletos.');
      }
    },
    crearCuenta () {
      if (this.$refs.formCuenta.validate()) {
        this.loadingButton = true;
        if (this.form.cuefundec_contrasenia === this.form.cuefundec_contrasenia2) {
          this.$storage.set('token', process.env.TOKEN_EXTERNO);
          this.form.perdec_fecha_nacimiento = this.date;
          this.$service
          .post(`control_tarjeta/cuenta`, { datos: this.form, code: this.sha256DatosSegip })
          .then(response => {
            this.$storage.remove('token');
            if (response) {
              this.$storage.set('token', response.token);
              this.perdec_codigo = response.inf_complemento;
              this.$message['success'](response.err_mensaje);
              this.e13 = 3;
              this.clearLoaders();
            } else {
              this.clearLoaders();
            }
          }).catch(err => {
            this.$storage.remove('token');
            console.log(err);
            this.clearLoaders();
          });
          this.$storage.remove('token');
        } else {
          this.$message['warning']('Las contraseñas no coinciden, favor validar');
          this.clearLoaders();
        }
      } else {
        this.$message['warning']('Por Favor revise los datos requeridos..');
        this.clearLoaders();
      }
    },
    clearLoaders () {
      this.loader = null;
      this.loadingButton = false;
      this.buttonCancel = false;
    },
    formatDate (date) {
      if (!date) return null;
      const [year, month, day] = this.date.split('-');
      return `${day}/${month}/${year}`;
    },
    parseDate (date) {
      if (!date) return null;
      const [day, month, year] = date.split('/');
      return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`;
    }
  },
  watch: {
    'form.correo1' (val) {
      if (this.form.correo1 !== '' || this.form.correo1 !== null) {
        this.correoOk = this.form.correo1 === '' || this.form.correo1 === null ? true : this.validarCorreo(this.form.correo1);
        this.correoRule = [v => this.correoOk || 'El correo no tiene el formato correcto'];
      } else {
        this.correoOk = false;
      }
    }
  }
};
</script>
<style lang="scss">
@import '../../admin/auth/login.scss';
</style>



// WEBPACK FOOTER //
// src/components/portal/login/CrearCuenta.vue